import React from "react";
import { SURFACE_STATUS } from "../classicSite.constants";

const STATUS_LABELS = {
  [SURFACE_STATUS.BLOCKED]: "Legacy-managed",
  [SURFACE_STATUS.HYBRID]: "Hybrid (Django)",
  [SURFACE_STATUS.PARTIAL]: "Partial",
};

/**
 * Read-only card for surfaces managed in Django classic_site (billing, etc.).
 */
export default function LegacyManagedCard({
  title,
  description,
  djangoUrl,
  status = SURFACE_STATUS.BLOCKED,
  phaseNote,
}) {
  const label = STATUS_LABELS[status] || "Blocked";

  return (
    <article className="cs-legacy-card">
      <div className="cs-legacy-card__header">
        <h3 className="cs-legacy-card__title">{title}</h3>
        <span className={`cs-badge cs-badge--${status}`}>{label}</span>
      </div>
      <p className="cs-legacy-card__desc">{description}</p>
      {phaseNote ? <p className="cs-legacy-card__phase">{phaseNote}</p> : null}
      {djangoUrl ? (
        <a
          className="cs-legacy-card__link"
          href={djangoUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open in Django → {djangoUrl}
        </a>
      ) : null}
    </article>
  );
}
